import { useEffect, useState } from 'react';
import '../../components/Diary/DiaryStyles.css';
import { getJobsForSchedulerList, submitEvent, removeSchedulerJob, getEventsForScheduler, updateEvent } from '../../data/jobData';
import { getEmployeesForDiary } from '../../data/employeeData';
import { useToast } from '../../contexts/ToastContext';
import EventCalendar2 from '../../components/Diary/EventCalendar2';
import EventCalendar from '../../components/Diary/EventCalendar';

// interface SchedulerEvent {
//   id: number | undefined;
//   title: string | undefined;
//   StartTimezone?: null;
//   start: Date;
//   end: Date;
//   schedulerId?: number[];
// }

export interface JobDataItem {
  jobId: number;
  ref: number;
  worktype: string;
  client: string;
  employeeProjectmanager: string;
  employeeProjectmanagerId: number;
  site: string;
  description: string;
  scheduledStartDate: string;
  scheduledEndDate: string;
  scheduledEmployeeId: number;
  refFormatted: string;
}

export interface resourceData {
  employeeId: number;
  employeeName: string;
  department: string;
  departmentColourHex: string;
}

interface DiaryProps {
  lockEdit: boolean;
}

const Diary = (props: DiaryProps) => {
  const [scheduledEvents, setScheduledEvents] = useState<any[]>([]);
  const [jobDataUnscheduled, setJobDataUnscheduled] = useState<JobDataItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [resources, setResources] = useState<resourceData[]>([]);
  const [time, setTime] = useState(Date.now());

  console.log('Diary lockEdit:', props.lockEdit);

  const currentYear = new Date().getFullYear();

  const parseAdjust = (eventDate: any) => {
    const date = new Date(eventDate);
    date.setFullYear(currentYear);
    return date;
  };

  //Get events method
  const getScheduledEvents = async (filterIds?: number[]) => {
    const scheduledData = await getEventsForScheduler(false, false, filterIds);
    const x = scheduledData;
    setScheduledEvents(x);
  }

  // //Get unscheduled events method
  // const getNonScheduledEvents = async () => {
  //   const nonScheduledData = await getJobsForSchedulerList(false, false);
  //   setJobDataUnscheduled(nonScheduledData);
  // }

  //Get resources method
  const getResources = async (filterIds?: number[]) => {
    const resourceData = await getEmployeesForDiary(true, filterIds);
    setResources(resourceData);
  }

  const refreshData = () => {
    getScheduledEvents();
    // getNonScheduledEvents();
    getResources();
  }

  const { showToast } = useToast()

  const updateJobEvent = async (id: number, newStartDate: string, newEndDate: string, employeeId: number[]) => {
    try {
      await submitEvent(id, newStartDate, newEndDate, employeeId);
      showToast(`Job successfully moved`, 'success');
      getScheduledEvents();
      // getNonScheduledEvents();
    } catch (error) {
      console.error("Failed to fetch job data:", error);
      showToast("Failed to move job.", "error");
    }
  }

  const eventUpdate = async (id: number, newStartDate: Date, newEndDate: Date, employeeId: number[]) => {
    try {

      const start = new Date(newStartDate);
      const end = new Date(newEndDate);

      await updateEvent(id, start, end, employeeId);
      showToast(`Event successfully updated`, 'success');
      getScheduledEvents();
      // getNonScheduledEvents();
    } catch (error) {
      console.error("Failed to fetch job data:", error);
      showToast("Failed to move job.", "error");
    }
  }

  const getJobInfoForRemove = (id: number) => {
    const fetchJobData = async () => {
      try {
        removeSchedulerJob(id);

        showToast(`Job removed`, 'success');
        getScheduledEvents();
      } catch (error) {
        console.error("Failed to fetch job data:", error);
        showToast("Failed to move job.", "error");
      }
    };

    fetchJobData();
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const unscheduledData = await getJobsForSchedulerList(false, false);
        const resourceData = await getEmployeesForDiary(true);

        getScheduledEvents();
        setJobDataUnscheduled(unscheduledData);
        setResources(resourceData);
      } catch (error) {
        console.error("Error fetching data:", error);
        showToast("Failed to fetch job data.", "error");
      }
    };

    fetchData().then(() => {
      setLoading(false);
    });
  }, []);

  const handleFilterData = (ids?: number[]) => {
    getResources(ids);
    getScheduledEvents(ids);
  }

  return (
    <div style={{ padding: "1.5em" }}>
      <div className="diary__header">
        <div className='grid__title__single'>Diary</div>
      </div>

      {
        loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {/* <EventCalendar 
              onScheduledData={scheduledEvents}
              onUnscheduledData={jobDataUnscheduled}
              onGetJobInfoForUpdate={updateJobEvent}
              onRemoveItem={getJobInfoForRemove}
              onResources={resources}
              onEventEditSubmit={eventUpdate}
              onFilterData={handleFilterData}
            /> */}

{/* 
              // onScheduledData={scheduledEvents}
              // onUnscheduledData={jobDataUnscheduled}
              // onGetJobInfoForUpdate={updateJobEvent}
              // onRemoveItem={getJobInfoForRemove}
              // onResources={resources}
              // onEventEditSubmit={eventUpdate}
              // onFilterData={handleFilterData} */}
              
            </div>
            <EventCalendar2
                lockEdit={props.lockEdit}
                resources={resources}
                scheduleData={scheduledEvents}
                unscheduledData={jobDataUnscheduled}
                onFilterDataChange={handleFilterData}
                refreshData={refreshData}
                onEventEditSubmit={eventUpdate}
                getScheduledEvents={getScheduledEvents} 
                onRemoveItem={getJobInfoForRemove} />            
          </>
        )
      }
    </div>
  );
}

export default Diary;